import { z } from 'zod';

import { isoDatetimeToDate } from '../../codecs';
import {
  createSharedPlayerReportDataSchema,
  createSharedSessionReportDataSchema,
  createSharedWeeklyReportDataSchema,
} from './create-shared-report-data.schema';

export type SharedReportId = SharedReport['id'];

export type SharedReportBase = z.output<typeof sharedReportBaseSchema>;
export type SharedReportBaseDTO = z.input<typeof sharedReportBaseSchema>;

/** The envelope every shared report carries, whatever kind of report it points at. */
export const sharedReportBaseSchema = z.object({
  tenantId: z.string(),
  teamId: z.string(),
  id: z.string(),

  createdAt: isoDatetimeToDate,
  updatedAt: isoDatetimeToDate,

  createdBy: z.string(),
  expiresAt: isoDatetimeToDate,
  reference: z.string(),
  token: z.string(),
});

export type SharedPlayerReport = z.output<typeof sharedPlayerReportSchema>;
export type SharedPlayerReportDTO = z.input<typeof sharedPlayerReportSchema>;

export const sharedPlayerReportSchema = sharedReportBaseSchema.extend(
  createSharedPlayerReportDataSchema.shape,
);

export type SharedSessionReport = z.output<typeof sharedSessionReportSchema>;
export type SharedSessionReportDTO = z.input<typeof sharedSessionReportSchema>;

export const sharedSessionReportSchema = sharedReportBaseSchema.extend(
  createSharedSessionReportDataSchema.shape,
);

export type SharedWeeklyReport = z.output<typeof sharedWeeklyReportSchema>;
export type SharedWeeklyReportDTO = z.input<typeof sharedWeeklyReportSchema>;

export const sharedWeeklyReportSchema = sharedReportBaseSchema.extend(
  createSharedWeeklyReportDataSchema.shape,
);

export type SharedReport = z.output<typeof sharedReportSchema>;
export type SharedReportDTO = z.input<typeof sharedReportSchema>;

export const sharedReportSchema = z.discriminatedUnion('type', [
  sharedPlayerReportSchema,
  sharedSessionReportSchema,
  sharedWeeklyReportSchema,
]);
